import { ChannelContext } from '@/contexts/channel.context';
import { PlayIcon } from '@/icons/play';
import { getMinutes, getHours } from 'date-fns';
import React from 'react';
import { useContext } from 'react';
import { useCallback } from 'react';
import { useState } from 'react';
import { isLiveNowContent } from 'utils';

type Props = {
  featured: boolean;
  content: any;
};

const ChannelGridRowContent: React.FC<Props> = ({
  featured,
  content,
}: Props) => {
  const { nowPlaying, setNowPlaying, setMainPlaylist } =
    useContext(ChannelContext);
  const [isLive] = useState(() => isLiveNowContent(content));

  const handlePlayClick = useCallback(() => {
    setNowPlaying(content);
  }, [setNowPlaying, content]);

  const handleContentClick = useCallback(() => {
    if (!featured) {
      setNowPlaying(content);
      setMainPlaylist(content.playlist);
    }
  }, [featured, setNowPlaying, content, setMainPlaylist]);
  return (
    <div
      className={`flex flex-col md:flex-row ${
        featured ? 'h-[90px]' : 'h-full'
      }`}
      onClick={handleContentClick}
    >
      <div
        className={`h-full cursor-pointer ${
          featured ? 'text-black' : 'text-white justify-center '
        } flex flex-col flex-grow space-y-1`}
      >
        <div className="font-semibold">{content.film_title}</div>
        {featured && (
          <div className="hidden md:block text-sm w-2/3">
            <p className="line-clamp-3">
              {content.start && content.end && (
                <span className="font-bold">
                  {getHours(new Date(content.start))}:
                  {getMinutes(new Date(content.start))}
                  {' - '}
                  {getHours(new Date(content.end))}:
                  {getMinutes(new Date(content.end))}
                  {' | '}
                </span>
              )}
              {content.description_es}
            </p>
          </div>
        )}
      </div>
      {featured && (
        <div className="pr-5 flex flex-row md:flex-col items-end justify-between">
          <>
            {isLive ? (
              <div className="text-center text-black border border-black rounded-xl text-sm py-0.5 font-semibold w-16">
                {isLive && 'Live'}
              </div>
            ) : content['@type'] === 'Schedule' ? (
              <div className="text-center text-black border border-black rounded-xl text-sm py-0.5 font-semibold w-32">
                Coming next
              </div>
            ) : (
              <div className="text-center text-black border border-black rounded-xl text-sm py-0.5 font-semibold w-28">
                On demand
              </div>
            )}
            {content['@type'] !== 'Schedule' && (
              <button
                className="transition-opacity duration-300 ease-in-out flex items-center justify-around px-4 space-x-3 text-white border-none bg-black rounded-lg text-sm py-2 font-semibold disabled:opacity-25 z-40"
                onClick={handlePlayClick}
                disabled={nowPlaying?._id === content._id}
              >
                <span>Play</span>
                <PlayIcon className="w-3 ml-1" />
              </button>
            )}
          </>
        </div>
      )}
    </div>
  );
};

export default ChannelGridRowContent;
